(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2611],{

/***/ 2548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'InfoOutlined');
exports.Z = _default;

/***/ }),

/***/ 37137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking-support",
      function () {
        return __webpack_require__(6685);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SupportHOC": function() { return /* binding */ SupportHOC; },
  "default": function() { return /* binding */ booking_support; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Support/Support.module.scss
var Support_module = __webpack_require__(64995);
var Support_module_default = /*#__PURE__*/__webpack_require__.n(Support_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/index.js + 25 modules
var components = __webpack_require__(60306);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(21023);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(48999);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
;// CONCATENATED MODULE: ./components/Support/Support.jsx















var theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#0a0a0a"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#0a0a0a"
    }
});
var Support = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (router.asPath.includes("#")) {
            var section = router.asPath.split("#")[1];
            document.querySelector("a[name=".concat(section, "]")).scrollIntoView();
        }
    }, [
        router
    ]);
    var HtmlTooltip = (0,styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
        var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
            "className"
        ]);
        return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            classes: {
                popper: className
            }
        }));
    })(function(param) {
        var theme = param.theme;
        return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
            backgroundColor: "#f5f5f9",
            color: "rgba(0, 0, 0, 0.87)",
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: "1px solid #dadde9"
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Support_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (Support_module_default()).topImage,
                    src: "".concat("https://media.first-class.com/", "assets/cookie_front.jpeg"),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "center 70%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("container", "font-libre"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BCBreadcrumbs */.k7, {
                        headerText: "Support"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Support_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "support",
                            className: "menu-marg-fix",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row section vision content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "column large-16 large-centered",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: classnames_default()((Support_module_default()).welcome, "font-fragment"),
                                            children: "Welcome to First-Class.com"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "flex justify-center",
                                            children: "If you have a question regarding an existing booking please contact our booking team directly:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                className: "table-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Country / Zone"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: "Phone"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Australia"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+61 2 9061 70 19"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Canada"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+1 647 956 01 77"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Denmark"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+45 32 46 30 40"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Great Britain"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+44 203 455 03 90"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Ireland"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+35 314 372 539"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "India"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+91 117 181 69 96"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Norway"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+47 219 361 10"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "Sweden"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+46 8 525 099 29"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "United States"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+1 786 405 85 11"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTooltip, {
                                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                children: "United Arab Emirates, Brasil, Hong Kong, Indonesia, Israel, Japan, South Korea, Malaysia, New Zealand, Philippines, Qatar, Saudi Arabia, Singapore, Thailand, Taiwan, Vietnam, South Africa"
                                                                            }),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                style: {
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 6
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "English USD Zone"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+1 786 405 85 11"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTooltip, {
                                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                children: "Austria, Belgium, Switzerland, Czechia, Germany, Finland, France, Greece, Italy, Netherlands, Poland, Portugal, Romania, Turkey, Ukraine"
                                                                            }),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                style: {
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 6
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "English Euro Zone"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+44 203 455 03 90"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTooltip, {
                                                                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                children: "Argentina, Bolivia, Chile, Colombia, Costa Rica, Ecuador, Guatemala, Honduras, M\xe9xico, Nicaragua, Panama, Peru, Puerto Rico, Paraguay, El Salvador, Uruguay"
                                                                            }),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                style: {
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 6
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Latin America USD Zone"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {})
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                        children: "+525 541 614 215"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/booking-support.jsx





var SupportHOC = function(param) {
    var setLoginDialogState = param.setLoginDialogState;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com", "/booking-support")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Learn more about First-Class.com, your trusted source for luxury travel and lifestyle content. Discover our mission, team, and dedication to providing premium insights"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Support First-Class: Your Premium Travel Resource"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Support, {
                setLoginDialogState: setLoginDialogState
            })
        ]
    });
};
/* harmony default export */ var booking_support = ((0,Layout/* withLayout */.X)(SupportHOC, true));


/***/ }),

/***/ 64995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"Support_top__eKnId","content":"Support_content__k_N9B","welcome":"Support_welcome__ZtElu"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(37137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);